/**
 * @fileoverview ESM mirror of ../permissionKeyFor.js.
 * @module @puffin-core/cross-app-policy/permissionKeyFor
 */

import { APP_REGISTRY } from './registry.js';

function permissionKeyFor(appKey) {
  if (typeof appKey !== 'string' || appKey.length === 0) {
    throw new TypeError('permissionKeyFor: app key is required (non-empty string)');
  }
  if (!Object.prototype.hasOwnProperty.call(APP_REGISTRY, appKey)) {
    throw new Error(`permissionKeyFor: unknown app key "${appKey}"`);
  }
  return `${appKey}:access`;
}

export { permissionKeyFor };
